import { qsRequired } from '@/scripts/core/global'
import { UcoastEl } from '@/scripts/core/UcoastEl'

type FormMessageType = 'INVALID_INPUT' | 'ERROR' | 'ACTIVATION_SENT'
export class ActivateCustomer extends UcoastEl {
	static htmlSelector = 'activate-customer'
	emailInput: HTMLInputElement
	form: HTMLFormElement
	route: string
	invalidInputMessage: HTMLElement
	generalErrorMessage: HTMLElement
	activationSentMessage: HTMLElement

	constructor() {
		super()
		this.emailInput = qsRequired('input[name="email"]', this)
		this.form = qsRequired('form', this)
		this.route = this.form.action
		this.form.addEventListener('submit', this.onSubmit.bind(this))
		this.invalidInputMessage = qsRequired(
			'[data-message="invalid-input"]',
			this
		)
		this.generalErrorMessage = qsRequired('[data-message="general"]', this)
		this.activationSentMessage = qsRequired(
			'[data-message="activation-sent"]',
			this
		)
	}
	async onSubmit(event: Event) {
		event.preventDefault()
		const email = this.emailInput.value.trim()
		if (!email) {
			this.showMessage('INVALID_INPUT')
			return
		}
		try {
			const response = await fetch(this.route, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ email }),
			})
			const json = await response.json()
			this.showMessage(json.message)
		} catch(e) {
			this.showMessage('ERROR')
		}
	}
	showMessage(message: FormMessageType) {
		this.invalidInputMessage.classList.add('hidden')
		this.generalErrorMessage.classList.add('hidden')
		this.activationSentMessage.classList.add('hidden')
		switch (message) {
			case 'INVALID_INPUT':
				this.invalidInputMessage.classList.remove('hidden')
				break
			case 'ERROR':
				this.generalErrorMessage.classList.remove('hidden')
				break
			case 'ACTIVATION_SENT':
				this.activationSentMessage.classList.remove('hidden')
				break
		}
	}
}
